import {
  Accepted_instance1051nmidder43 as Accepted_instance,
  Rejected_instances6p2tssc0jwo as Rejected_instance,
} from './CommandResult.mjs';
import { noWhenBranchMatchedException2a6r7ubxgky5j as noWhenBranchMatchedException } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function voidResult(_this__u8e3s4) {
  var tmp;
  switch (_this__u8e3s4) {
    case true:
      tmp = Accepted_instance;
      break;
    case false:
      tmp = Rejected_instance;
      break;
    default:
      noWhenBranchMatchedException();
      break;
  }
  return tmp;
}
//region block: exports
export {
  voidResult as voidResult3hb4jxf0f2mcw,
};
//endregion

//# sourceMappingURL=VoidResult.mjs.map
